<template>
  <form>
    <div ref="stepper" class="bs-stepper">
    <!-- Header: define each step trigger -->
    <div class="bs-stepper-header" role="tablist">
      <div class="step" data-target="#step-1">
        <button
          class="step-trigger"
          role="tab"
          id="step-1-trigger"
          aria-controls="step-1"
        >
          <span class="bs-stepper-circle">1</span>
          <span class="bs-stepper-label">Job Information</span>
        </button>
      </div>
      <div class="line"></div>
      <div class="step" data-target="#step-2">
        <button
          class="step-trigger"
          role="tab"
          id="step-2-trigger"
          aria-controls="step-2"
        >
          <span class="bs-stepper-circle">2</span>
          <span class="bs-stepper-label">Summary</span>
        </button>
      </div>
      <div class="line"></div>
      <div class="step" data-target="#step-3">
        <button
          class="step-trigger"
          role="tab"
          id="step-3-trigger"
          aria-controls="step-3"
        >
          <span class="bs-stepper-circle">3</span>
          <span class="bs-stepper-label">Financing</span>
        </button>
      </div>
    </div>

    <!-- Content: panels for each step -->
    <div class="bs-stepper-content">
      <div
        id="step-1"
        class="content"
        role="tabpanel"
        aria-labelledby="step-1-trigger"
      >
        <!-- Step 1 form fields… -->
        <h4 class="header-title mb-1">{{$t('job.form.information')}}</h4>
        <p class="sub-header"></p>
        <div class="row">
          <div class="col-md-12">
            <div class="row border-bottom mb-3">
              <TextField 
                :placeholder="$t('job.form.title.placeholder')"
                :label="$t('job.form.title.label')"
                :error="$v.model.title.$error"
                :errorMessage="$v.model.title.errorMessage"
                v-model="model.title"
                class="col-md-12"
              />
              <Select
                autoload
                class="col-md-6"
                endpoint="all"
                moduleName="company"
                track-by="_id"
                valueField="_id"
                textField="name"
                :placeholder="$t('job.form.company.placeholder')"
                :label="$t('job.form.company.label')"
                :error="$v.model.company_id.$error"
                :errorMessage="$v.model.company_id.errorMessage"
                v-model="model.company_id"
                @selected="onSelectCompany"
                />

              <Select
                autoload
                class="col-md-6"
                track-by=""
                valueField=""
                textField=""
                moduleName="employment_type_options"
                :placeholder="$t('job.form.employment_type.placeholder')"
                :label="$t('job.form.employment_type.label')"
                :error="$v.model.employment_type.$error"
                :errorMessage="$v.model.employment_type.errorMessage"
                v-model="model.employment_type"
              />

              <Select
                autoload
                moduleName="levels"
                class="col-md-6"
                track-by=""
                textField=""
                :placeholder="$t('job.form.experience.placeholder')"
                :label="$t('job.form.experience.label')"
                v-model="model.level"
              />

              <TextField 
                :placeholder="$t('job.form.slots.placeholder')"
                :label="$t('job.form.slots.label')"
                :error="$v.model.slots.$error"
                :errorMessage="$v.model.slots.errorMessage"
                v-model="model.slots"
                type="number"
                class="col-md-6"
              />
            </div>
          </div>

          <Select
            autoload
            moduleName="jobTypes"
            class="col-md-6"
            valueField=""
            textField=""
            :placeholder="$t('job.form.job_type.placeholder')"
            :label="$t('job.form.job_type.label')"
            v-model="model.job_type"
          />

          <div class="form-group col-md-6">
            <Multiselect
              autoload
              moduleName="function"
              endpoint="all"
              v-model="model.function_id"
              :searchable="true"
              :multiple="false"
              :placeholder="$t('job.form.function.placeholder')"
              :clear-on-select="false"
              :close-on-select="false"
              :show-labels="false"
              track-by="_id"
              label="name"
              :textLabel="$t('job.form.function.label')"
            />
          </div>

          <Select
            autoload
            moduleName="languageLevels"
            valueField=""
            textField=""
            class="col-md-6"
            :placeholder="$t('job.form.english.placeholder')"
            :label="$t('job.form.english.label')"
            v-model="model.english_level"
          />

        </div>
        <div class="d-flex justify-content-end">
          <b-button variant="primary" @click="goToNext(2)">Next</b-button>
        </div>
       

      </div>
      <div
        id="step-2"
        class="content"
        role="tabpanel"
        aria-labelledby="step-2-trigger"
      >
        <!-- Step 1 form fields… -->
        <div class="form-group col-12">
          <div class="textOnInput">
            <label for="">{{$t('job.form.summary.label')}}</label>
            <vue-editor
              id="editor1"
              :placeholder="$t('job.form.summary.placeholder')"
              v-model="model.summary"
            />
          </div>
        </div>

        <div class="form-group col-12">
          <div class="textOnInput">
            <label for="">{{$t('job.form.full_details.label')}}</label>
            <vue-editor
              id="editor2"
              :placeholder="$t('job.form.full_details.placeholder')"
              v-model="model.description"
            />
          </div>
        </div>

        <div class="form-group col-12">
          <div class="textOnInput">
            <label for="">{{$t('job.form.additional_information.label')}}</label>
            <vue-editor
              id="editor3"
              :placeholder="$t('job.form.additional_information.placeholder')"
              v-model="model.remarks"
            />
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <b-button  variant="dark" @click="goToPrev(1)" class="mr-2">Previous</b-button>
          <b-button variant="primary" @click="goToNext(3)">Next</b-button>
        </div>

      </div>
      <div
        id="step-3"
        class="content"
        role="tabpanel"
        aria-labelledby="step-3-trigger"
      >
        <!-- Step 2 form fields… -->
        <h4 class="header-title mt-0 mb-1 mt-md-5">{{ $t('job.form.financing') }}</h4>
        <p class="sub-header"></p>
        <div class="row mb-3">
          <Select
            autoload
            moduleName="currency"
            endpoint="all"
            class="col-md-12"
            :placeholder="$t('job.form.currency.placeholder')"
            :label="$t('job.form.currency.label')"
            :error="$v.model.currency_id.$error"
            :errorMessage="$v.model.currency_id.errorMessage"
            v-model="model.currency_id"
            @selected="onSelectCurrency"
          />
            <div class="form-group col-md-12">
              <b-form-checkbox 
                v-model="model.use_min_max_salary" 
                name="check-button" 
                switch
                @change="onBlur"
              >
                Min and Max Salary
              </b-form-checkbox>
            </div>
            <div class="form-group col-md-12" v-if="model.use_min_max_salary">
              <label for="" class="form-label">{{ $t('job.form.min_salary.label') }}</label>
              <currency-input
                class="form-control"
                placeholder="xxx,xxx"
                v-model="model.min_salary"
                :precision="!isYenCurrency ? 2 : 0"
              />
            </div>

            <div class="form-group col-md-12" v-if="model.use_min_max_salary">
              <label for="" class="form-label">{{ $t('job.form.max_salary.label') }}</label>
              <currency-input
                class="form-control"
                placeholder="xxx,xxx"
                v-model="model.max_salary"
                :precision="!isYenCurrency ? 2 : 0"
              />
            </div>
            <div class="col-md-12" v-if="!model.use_min_max_salary">
              <TextField 
                :placeholder="$t('job.form.salary_range')"
                :label="$t('job.form.salary_range')"
                v-model="model.salary"
                
              />
            </div>
          

        </div>

        <h4 class="header-title mt-0 mb-3">{{ $t('job.form.commission_setup') }}</h4>
        <div class="form-group">
          <b-form-checkbox 
            v-model="model.fixed" 
            name="check-button" 
            switch
            @change="onBlur"
          >
            {{ $t('job.form.use_fixed_rate') }}
          </b-form-checkbox>
        </div>
        <div class="row">
          <TextField 
            :max="model.fixed ? 0 : 100"
            :placeholder="model.fixed ? 'xx,xxx' : '%'"
            :label="$t('job.form.commission_rate.label')"
            type="number"
            class="col-md-6"
            v-model="model.rate"
          />

          <Select
            autoload
            moduleName="paymentTerms"
            valueField=""
            textField=""
            class="col-md-6"
            :placeholder="$t('job.form.payment_term.placeholder')"
            :label="$t('job.form.payment_term.label')"
            v-model="model.payment_term"
          />

          <div class="form-group col-md-6">
            <div class="textOnInput">
              <label class="form-control-label">
                {{ $t('job.form.city.label') }}
              </label>
              <CustomSelect
                v-model="model.city"
                :options="cities"
                :searchable="true"
                :placeholder="$t('job.form.city.placeholder')"
                :clear-on-select="false"
                :close-on-select="true"
                :show-labels="false"
                
                track-by="value"
                label="text"
                textField="text"
                valueField="value"
                @tag="addTagCity"
                :taggable="true"
                :multiple="false"
              />
            </div>
          </div>

          <TextField 
            :placeholder="$t('job.form.country.placeholder')"
            :label="$t('job.form.country.label')"
            :error="$v.model.country.$error"
            :errorMessage="$v.model.country.errorMessage"
            v-model="model.country"
            class="col-md-6"
          />

          <!-- <Select
            moduleName="company"
            endpoint="getContactPersons"
            class="col-md-12"
            ref="contactPersons"
            :placeholder="$t('job.form.contact_person.placeholder')"
            :label="$t('job.form.contact_person.label')"
            v-model="model.contact_person"
            :autoload="true"
            track-by="_id"
            textField="email"
            :parameters="{
              id: model.company_id._id
            }"
          /> -->

          <!-- <div class="form-group col-md-12">
            <Multiselect
              autoload
              moduleName="industry"
              endpoint="all"
              v-model="model.industry_id"
              :searchable="true"
              :multiple="false"
              :placeholder="$t('job.form.industry.placeholder')"
              :clear-on-select="false"
              :close-on-select="false"
              :show-labels="false"
              track-by="_id"
              label="name"
              :textLabel="$t('job.form.industry.label')"
            />
          </div> -->
          <div class="form-group col-md-12">
            <div class="textOnInput">
              <label for="" class="form-label">{{$t('job.form.skills.label')}}</label>
              <vue-tags-input
                class="form-group"
                v-model="model.tag"
                :tags="model.tags"
                @tags-changed="newTags => model.tags = newTags"
                :placeholder="$t('job.form.skills.placeholder')"
              />
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <div class="btn-group mr-2">
            <button id="preview-job" type="button" class="btn btn-outline-info" @click.prevent="onPreview">
              <i class="uil-eye" />
            </button>
            <b-tooltip target="preview-job" placement="top">Preview</b-tooltip>
          </div>  
          <b-button  variant="dark" @click="goToPrev(2)" class="">Previous</b-button>
        </div>
      </div>
    </div>
    </div>
    <div>
    </div>
    <Dialog
      centered
      title="Preview Job"
      ref="previewJob"
      bodyClass="modalBodyContainer px-4"
      size="xl"
      :component="computedViewJobComponent"
      :parameters="{ model, submitted, hasNoSetting }"
    />
  </form>
</template>

<script>
import FormMixin from '@mixins/form'
import 'bs-stepper/dist/css/bs-stepper.min.css';
import Stepper from 'bs-stepper';

import { required } from 'vuelidate/lib/validators'
import { VueEditor } from 'vue2-editor'
import Dropdown from '@src/static/dropdown'
import { mapActions } from 'vuex'
import VueTagsInput from '@johmun/vue-tags-input';
import Dialog from '@components/offcanvas'
import CustomSelect from 'vue-multiselect'

export default {
  components: {
    TextField: () => import('@components/form2/textfield.vue'),
    Select: () => import('@components/form2/select'),
    Multiselect: () => import('@components/form2/select/multiselect'),
    CustomSelect,
    VueEditor,
    VueTagsInput,
    Dialog
  },
  mixins: [ FormMixin ],
  data(){
    return {
      stepper: null,
      Dropdown,
      model:{
        company_id:'',
        title:'',
        city:'',
        country:'',
        employment_type:'',
        industry:'',
        level:'',
        summary:null,
        description:null,
        remarks:null,
        min_salary:null,
        max_salary:null,
        rate:null,
        industry_id: [],
        function_id: [],
        currency_id: [],
        slots:0,
        contract_length: 0,
        fixed:false
      },
      cities: [],
      previewData: {},
      submitted: false,
      hasNoSetting: true,
      isYenCurrency: false
    }
  },
  validations: {
    model:{
      title: { required },
      country: { required },
      city: { required },
      company_id: { required },
      employment_type: { required },
      currency_id: { required },
      slots: { required },
    }
  },
  computed: {
    computedViewJobComponent() {
      return () => import('./view.vue')
    }
  },
  methods: {
    ...mapActions('company', {'findCompany':'find'}),
    onBlur(){
      if(parseInt(this.model.rate) > 100){
        this.model.rate = 100
      }
    },
    onSelectCompany(val) {
      let selected = { ...val }
      if (selected && Object.entries(selected).length) {
        this.company_id = selected
        this.model.rate = selected.rate.$numberDecimal
        this.model.industry_id = selected.industry_id
        this.model.function_id = selected.function_id
        this.model.fixed = selected.fixed
        this.model.remarks = this.model.remarks ? this.model.remarks : selected.remarks
        this.model.city = selected.city
        this.model.country = selected.country
        if(this.is_mounted){
          this.original_model = { ...this.model }
          this.is_mounted = false
        }

        // this.$refs.contactPersons.params.id = val._id
        // this.$refs.contactPersons.fetchData()
        // this.$store.dispatch('company/find',{
        //   id:val._id
        // }).then(data => {
        //   var _data = data.data
        //   if(_data.default_contact)
        //     this.model.contact_person = _data.default_contact
        // })
      }
    },
    getCityList(){
      let cityList = this.Dropdown.cityList.map( res => {
        return res.replace(/\s+/g, '').toLowerCase();
      })
      .sort(function(a, b){return a.localeCompare(b)});
      for(let key in cityList){
        let city = {}
        city.value = cityList[key]
        city.text = cityList[key]
        this.cities.push(city)
      }
    },
    onPreview() {
      this.$refs.previewJob.show()
    },
    onSelectCurrency(val) {
      this.isYenCurrency = false
      if(val != null && val.code == "JPY") {
        this.isYenCurrency = true
      }
    },
    getCurrencyList() {
      this.$store.dispatch('currency/all').then( res => {
        if(res && res.data) {
          let defaultCurrency = res.data.filter( res => res.code == 'JPY')
          if(defaultCurrency.length > 0)
            this.model.currency_id = { ...defaultCurrency[0] }
        }
      }) 
    },
    addTagCity(val) {
      let newTag = val.toString()
      let isTag = this.cities.filter(el => { return el.value == newTag })

      let option = { 'text': newTag, 'value': newTag }
      if(isTag.length == 0){
        this.cities.push(option)
        this.model.city = option
      }
    },
    goToNext(step) {
      this.stepper.to(step)
    },
    goToPrev(step) {
      this.stepper.to(step);
    },
  },
  mounted() {
    this.getCityList()
    this.getCurrencyList()
    this.stepper = new Stepper(this.$refs.stepper, {
      linear: true,
      animation: true,
    });
  }
}
</script>